var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 215.03 77.3",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#231f20;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M12.72,11.62H0L6.1,1.24H23.81V74.77H12.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M60.49,77.3l-8.15-6,17.58-24c-1,.13-1.77.23-2.43.29s-1.21.09-1.62.09a20.67,20.67,0,0,1-15.43-6.81A22.67,22.67,0,0,1,44,24.58,23.63,23.63,0,0,1,51.15,7.24,23.65,23.65,0,0,1,68.49,0,24.41,24.41,0,0,1,86,7.14,22.46,22.46,0,0,1,93.4,23.91q0,8.57-7.24,18.53ZM54.77,23.77a13.58,13.58,0,0,0,4,10,13.92,13.92,0,0,0,19.67,0A13.42,13.42,0,0,0,82.58,24a13.43,13.43,0,0,0-4.09-9.86,13.42,13.42,0,0,0-9.86-4,13.28,13.28,0,0,0-9.76,4A13.22,13.22,0,0,0,54.77,23.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M120.69,77.3l-8.15-6,17.58-24c-1,.13-1.77.23-2.43.29s-1.21.09-1.62.09a20.67,20.67,0,0,1-15.43-6.81,22.67,22.67,0,0,1-6.48-16.28,23.63,23.63,0,0,1,7.19-17.34A23.64,23.64,0,0,1,128.69,0a24.41,24.41,0,0,1,17.48,7.14,22.45,22.45,0,0,1,7.42,16.77q0,8.57-7.23,18.53ZM115,23.77a13.58,13.58,0,0,0,4,10,13.92,13.92,0,0,0,19.67,0A13.42,13.42,0,0,0,142.78,24a13.43,13.43,0,0,0-4.09-9.86,13.42,13.42,0,0,0-9.86-4,13.28,13.28,0,0,0-9.76,4A13.18,13.18,0,0,0,115,23.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M163.12,37.53q0-17.58,8.19-28Q178.65,0,189.08,0t17.76,9.48Q215,20,215,38t-8.19,28.48Q199.51,76,189.12,76t-17.81-9.47Q163.12,56,163.12,37.53Zm10.91,0q0,12.24,4.24,20.33t10.81,8q6.53,0,10.81-8T204.17,38q0-12-4.28-20t-10.81-7.91q-6.48,0-10.77,7.91T174,37.58Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg1);
export default __webpack_public_path__ + "static/media/1.f158d50759c765a75848cf9d2e32248f.svg";
export { ForwardRef as ReactComponent };